module.exports = "<img class=\"vodafone-logo\" *ngIf=\"isTheme == 'vodafone'\" src=\"assets/images/logo-vodafone.png\">\r\n\r\n<div class=\"survey-wrapper {{isTheme}}\" [class.mobile]=\"isMobile\">\r\n\r\n  <router-outlet></router-outlet>\r\n\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// L:/Vodafone/Happy Check/dev/vodhappycheck/src/app/app.component.html
// module id = ../../../../../src/app/app.component.html
// module chunks = main